import { render, staticRenderFns } from "./treeChart.vue?vue&type=template&id=641e90d2&scoped=true"
import script from "./treeChart.vue?vue&type=script&lang=js"
export * from "./treeChart.vue?vue&type=script&lang=js"
import style0 from "./treeChart.vue?vue&type=style&index=0&id=641e90d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641e90d2",
  null
  
)

export default component.exports